<ng-container *ngIf="row && item">
    <div
        class="view-action-buttons justify-content-center"
        [ngClass]="
        row[item.field] == ModifiedActionStatus.APPROVED
            ? 'approve'
            : row[item.field] == ModifiedActionStatus.PENDING
            ? 'pending'
            : row[item.field] == ModifiedActionStatus.PAID
            ? 'paid'
            : (row[item.field] == ModifiedActionStatus.REJECTED || row[item.field] == ModifiedActionStatus.DECLINE)
            ? 'rejected'
            : row[item.field] == ModifiedActionStatus.CLOSED
            ? 'closed'
            : row[item.field] == ModifiedActionStatus.OPEN
            ? 'open'
            : row[item.field] == ModifiedActionStatus.CANCELED
            ? 'rejected'
            : (row[item.field] == ModifiedActionStatus.COMPLETE || row[item.field] == ModifiedActionStatus.COMPLETED)
            ? 'paid'
            : row[item.field] == ModifiedActionStatus.RESCHEDULE
            ? 'closed'
            : row[item.field] == ModifiedActionStatus.INHOLD 
            ? 'closed'
            : row[item.field] == ModifiedActionStatus.ASSIGNED 
            ? 'closed'
            : row[item.field] == ModifiedActionStatus.UPCOMING 
            ? 'in-progress'
            : row[item.field] == ModifiedActionStatus.DISCUSSWITHHR 
            ? 'discuss-hr'
            :'in-progress'
        "
        >
        <span class="btn-text">{{
            row[item.field]
        }}</span>
    </div>
</ng-container>